/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
$(document).ready(function() {
    let maxDate = new Date($('#effectiveDate').text());
    let actualDate = Date.now();
    let diffDate = new Date(maxDate - actualDate);
    let days = (diffDate/1000/60/60/24)+1;
    $.datepicker.regional['es'] = {
        closeText : 'Cerrar',
        prevText : '<Ant',
        nextText : 'Sig>',
        currentText : 'Hoy',
        monthNames : [ 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre',
                        'Diciembre' ],
        monthNamesShort : [ 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul',
                            'Ago', 'Sep', 'Oct', 'Nov', 'Dic' ],
        dayNames : [ 'Domingo', 'Lunes', 'Martes', 'Mi\u00E9rcoles', 'Jueves',
                     'Viernes', 'S\u00E1bado' ],
        dayNamesShort : [ 'Dom', 'Lun', 'Mar', 'Mi\u00E9', 'Juv', 'Vie', 'S\u00E1b' ],
        dayNamesMin : [ 'Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'S\u00E1' ],
        weekHeader : 'Sm',
        dateFormat : 'dd-mm-yy',
        firstDay : 0,
        isRTL : false,
        showMonthAfterYear : false,
        yearSuffix : ''
    };
    $.datepicker.setDefaults($.datepicker.regional['es']);
    $('#dateModalReservation').datepicker({
        showAnim: "slideDown",
        defaultDate: new Date(),
        minDate : 0,
        altField: "#altFormatDateModalReservation",
        altFormat: "DD, d MM, yy",
        beforeShowDay: activeDays
    });

    $('#tooltipMembership').tooltip({
      show: null,
      position: {
        my: "left top",
        at: "left bottom"
      },
      open: function( event, ui ) {
        ui.tooltip.animate({ top: ui.tooltip.position().top + 10 }, "fast" );
      }
    });
    $('.tooltipModalReservations').tooltip({
      show: null,
      position: {
        my: "left top",
        at: "left bottom"
      },
      open: function( event, ui ) {
        ui.tooltip.animate({ top: ui.tooltip.position().top + 10 }, "fast" );
      }
    });
});




$('#sendCotization').submit(function(event){
    event.preventDefault();
    var link = $(this).attr('action');
    var count_error = 0;
    var formData = new FormData(document.getElementById("sendCotization"));
    if($('#nameModalReservation').val().length === 0){
        count_error++;
        $('.messagesModalReservation').text('Debe de escribir su nombre para poder solicitar la cotización.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#nameModalReservation').addClass('border-red');
        $('#nameModalReservation').focus();
    }else{
        $('#nameModalReservation').removeClass('border-red');
    }
    if($('#emailModalReservation').val().length === 0 && emailIsValid($('#emailModalReservation').val()) === false){
        count_error++;
        $('.messagesModalReservation').text('Ingrese un email válido.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#emailModalReservation').addClass('border-red');
        $('#emailModalReservation').focus();
    }else{
        $('#emailModalReservation').removeClass('border-red');
    }
    if(validateDate($('#dateModalReservation').val()) === false){
        count_error++;
        $('.messagesModalReservation').text('Ingrese una fecha válida.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#dateModalReservation').addClass('border-red');
        $('#dateModalReservation').focus();
    }else if(validateCurrentDate($('#dateModalReservation').val()) === false){
        count_error++;
        $('.messagesModalReservation').text('La fecha ingresada no puede ser igual a la fecha de hoy.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#dateModalReservation').addClass('border-red');
        $('#dateModalReservation').focus();
    }else{
        $('#dateModalReservation').removeClass('border-red');
    }
    
        
    if (count_error == 0) {
        $('.messagesModalReservation').text('');
        $('.messagesModalReservation').removeClass('alert-danger');
        $.ajax({
            url: link,
            type: "POST",
            dataType: "json",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function(){
                $('.messagesModalReservation').html('<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div>'+
                        '<div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>');
            },
            success: function(data){
                //console.log(data);
                //console.log(JSON.stringify(data));
                $('.messagesModalReservation').addClass('alert-success');
                $('.messagesModalReservation').html(data.messages);
                $('#dateModalReservation').val('');
                
            },
            error: function(data){
               $('.messagesModalReservation').addClass('alert-danger');
               $('.messagesModalReservation').html('Error al enviar la solicitud de cotización. '+
                       'Intente nuevamente, si el problema persiste pongase en contacto con el departamento de atención a socios para reportar el problema y/o '+
                       'con el departamento de reservaciones para solicitar su cotización.');
            }
        });
    }
});


$('#sendCotizationXeni').submit(function(event){
    event.preventDefault();
    let link = $(this).attr('action');
    //console.log(link);
    let valid = true;
    let formData = new FormData(document.getElementById("sendCotizationXeni"));
    //console.log($('#fechaSalida').val());
    //console.log($('#adult_num').val());
    //console.log($('#child_num').val());

    formData.append('date', $('#fechaSalida').val());
    formData.append('adults', $('#adult_num').val());
    formData.append('children', $('#child_num').val());

    if($('#nameModalReservationXeni').val().length === 0){
        valid = false;
        $('.messagesModalReservation').text('Debe de escribir su nombre para poder solicitar la cotización.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#nameModalReservationXeni').addClass('border-red');
        $('#nameModalReservationXeni').focus();
    }else{
        $('#nameModalReservationXeni').removeClass('border-red');
    }

    if($('#emailModalReservationXeni').val().length === 0 && emailIsValid($('#emailModalReservationXeni').val()) === false){
        valid = false;
        $('.messagesModalReservation').text('Ingrese un email válido.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#emailModalReservationXeni').addClass('border-red');
        $('#emailModalReservationXeni').focus();
    }else{
        $('#emailModalReservationXeni').removeClass('border-red');
    }
        
    if (valid) {
        $('.messagesModalReservation').text('');
        $('.messagesModalReservation').removeClass('alert-danger');
        $.ajax({
            url: link,
            type: "POST",
            dataType: "json",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function(){
                $('.messagesModalReservation').html('<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div>'+
                        '<div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>');
            },
            success: function(data){
                //console.log(data);
                //console.log(JSON.stringify(data));
                $('.messagesModalReservation').addClass('alert-success');
                $('.messagesModalReservation').html(data.messages);
            },
            error: function(data){
               $('.messagesModalReservation').addClass('alert-danger');
               $('.messagesModalReservation').html('Error al enviar la solicitud de cotización. '+
                       'Intente nuevamente, si el problema persiste pongase en contacto con el departamento de atención a socios para reportar el problema y/o '+
                       'con el departamento de reservaciones para solicitar su cotización.');
            }
        });
    }
});



$('#sendCotizationWeeks').submit(function(event){
    event.preventDefault();
    var link = $(this).attr('action');
    var count_error = 0;
    var formData = new FormData(document.getElementById("sendCotizationWeeks"));
    if($('#nameModalReservation').val().length === 0){
        count_error++;
        $('.messagesModalReservation').text('Debe de escribir su nombre para poder solicitar la cotización.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#nameModalReservation').addClass('border-red');
        $('#nameModalReservation').focus();
    }else{
        $('#nameModalReservation').removeClass('border-red');
    }
    if($('#emailModalReservation').val().length === 0 && emailIsValid($('#emailModalReservation').val()) === false){
        count_error++;
        $('.messagesModalReservation').text('Ingrese un email válido.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#emailModalReservation').addClass('border-red');
        $('#emailModalReservation').focus();
    }else{
        $('#emailModalReservation').removeClass('border-red');
    }
    if($('#dateModalReservationWeek').val() === '' || $('#dateModalReservationWeek').val() === '0'){
        count_error++;
        $('.messagesModalReservation').text('Ingrese una fecha válida.');
        $('.messagesModalReservation').removeClass('hidden');
        $('.messagesModalReservation').addClass('alert-danger');
        $('#dateModalReservationWeek').addClass('border-red');
        $('#dateModalReservationWeek').focus();
    }else{
        $('#dateModalReservationWeek').removeClass('border-red');
    }
    
        
    if (count_error == 0) {
        $('.messagesModalReservation').text('');
        $('.messagesModalReservation').removeClass('alert-danger');
        $.ajax({
            url: link,
            type: "POST", 
            dataType: "json",
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function(){
                $('.messagesModalReservation').html('<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div>'+
                        '<div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>');
            },
            success: function(data){
                //console.log(data);
                //console.log(JSON.stringify(data));
                $('.messagesModalReservation').addClass('alert-success');
                $('.messagesModalReservation').html(data.messages);
                $('#dateModalReservation').val('');
                
            },
            error: function(data){
               $('.messagesModalReservation').addClass('alert-danger');
               $('.messagesModalReservation').html('Error al enviar la solicitud de cotización. '+
                       'Intente nuevamente, si el problema persiste pongase en contacto con el departamento de atención a socios para reportar el problema y/o '+
                       'con el departamento de reservaciones para solicitar su cotización.');
            }
        });
    }
});




$('#cancelModalReservation').click(function(event){
    $('.messagesModalReservation').text('');
    $('.messagesModalReservation').removeClass('alert-danger');
    $('#numKidsModalReservation').val(0);
    $('#numAdultsModalReservation').val(1);
    $('#dateModalReservation').val('');
    $('#commentsModalReservation').text('');
});

$('#cotizaPackage').on('hidden.bs.modal', function (e) {
  $('.messagesModalReservation').text('');
    $('.messagesModalReservation').removeClass('alert-danger');
    $('#numKidsModalReservation').val(0);
    $('#numAdultsModalReservation').val(1);
    $('#dateModalReservation').val('');
    $('#commentsModalReservation').text('');
});


$('#numKidsModalReservation').change(function(event){
    if($(this).val() != '0'){
        $('#messageMenorModal').removeClass('hidden');
    }else{
        $('#messageMenorModal').addClass('hidden');
    }
});

function validateDate(date){
    var fechaf = date.split("-");
    if(fechaf.length === 3){
        var day = fechaf[0];
        var month = fechaf[1];
        var year = fechaf[2];
        var date = new Date(year,month,'0');
        if((day-0)>(date.getDate()-0)){
            return false;
        }
        return true;
    }
    return false;
}

function validateCurrentDate(date){
      var x=new Date();
      var fecha = date.split("-");
      x.setFullYear(fecha[2],fecha[1]-1,fecha[0]);
      var today = new Date();
 
      if (x > today)
        return true;
      else
        return false;
}

function emailIsValid (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function activeDays(in_date) { 
    let departure = $('#departureDate').text().toLowerCase();
    let habiles = new Array();
    let cont = 0
    if(departure.indexOf('domingo') != -1){
        habiles[cont] = 0; cont++;
    } 
    if(departure.indexOf('lunes') != -1){
        habiles[cont] = 1;cont++;
    }
    if(departure.indexOf('martes') != -1){
        habiles[cont] = 2;cont++;
    }
    if(departure.indexOf('miercoles') != -1 || departure.indexOf('miércoles') != -1){
        habiles[cont] = 3;cont++;
    }
    if(departure.indexOf('jueves') != -1){
        habiles[cont] = 4;cont++;
    }
    if(departure.indexOf('viernes') != -1){
        habiles[cont] = 5;cont++;
    }
    if(departure.indexOf('sabado') != -1 || departure.indexOf('sábado') != -1){
        habiles[cont] = 6;cont++;
    }
    if(departure.indexOf('diarias') != -1 || departure.indexOf('dárias') != -1 || departure.indexOf('pregunte') != -1 || departure.indexOf('pregúnte') || departure.indexOf('pregunté')){
        habiles[cont] = 0; cont++;
        habiles[cont] = 1; cont++;
        habiles[cont] = 2; cont++;
        habiles[cont] = 3; cont++;
        habiles[cont] = 4; cont++;
        habiles[cont] = 5; cont++;
        habiles[cont] = 6; cont++;
    }
        
    if(habiles.length > 0){
        return [($.inArray(in_date.getDay(), habiles) != -1)];
    }else{
        let validate = false;
        let arrayMonths = departure.split(';');
        let arrayDays = new Array();
        for(let i = 0; i < arrayMonths.length; i++){
            let monthYear = determineYearMonth(arrayMonths[i].split(':')[0]);
            let arrayAux = arrayMonths[i].split(':')[1].split(',');
            arrayDays[i] = {'year': monthYear[0],'month': monthYear[1], 'days': arrayAux};
            let month = in_date.getYear();
            let getYear = monthYear[0] - in_date.getYear();
            if(getYear == 1900){
                if(in_date.getMonth() == monthYear[1]){
                    for(let j=0; j<arrayAux.length; j++){
                        if(in_date.getDate() == parseInt(arrayAux[j])){
                            validate = true;
                            break;
                        }
                    }
                }
            }
        }
        
        return [validate];
    }
}

function determineYearMonth(str){
    //console.log(str);
    let aux = str.trim().split(' ');
    //console.log(aux);
    let arrayAux = {0: 2021, 1: null};
    switch(aux[0].trim()){
        case 'enero':
        case 'ene':
            arrayAux[1] = 0;
            break;
        case 'febrero':
        case 'feb':
            arrayAux[1] = 1;
            break;
        case 'marzo':
        case 'mar':
            arrayAux[1] = 2;
            break;
        case 'abril':
        case 'abr':
            arrayAux[1] = 3;
            break;
        case 'mayo':
        case 'may':
            arrayAux[1] = 4;
            break;
        case 'junio':
        case 'jun':
            arrayAux[1] = 5;
            break;
        case 'julio':
        case 'jul':
            arrayAux[1] = 6;
            break;
        case 'agosto':
        case 'ago':
            arrayAux[1] = 7;
            break;
        case 'septiembre':
        case 'sept':
            arrayAux[1] = 8;
            break;
        case 'octubre':
        case 'oct':
            arrayAux[1] = 9;
            break;
        case 'noviembre':
        case 'nov':
            arrayAux[1] = 10;
            break;
        case 'diciembre':
        case 'dic':
            arrayAux[1] = 11;
            break;
    }
    //console.log(arrayAux);
    return arrayAux;
}